import {LandingButtonLink} from '@app/components/landing-btn-link';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {useTranslation} from '@app/hooks/use-translation';
import {Image} from '@app/components/Image';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';

export const IndexChristmasSection = () => {
	const {t} = useTranslation();

	return (
		<LandingIllustrationSection
			imagePosition="right"
			description={
				<>
					<LandingHeading as="h2">
						{t('hubmomentslandingpage_title_chistmas_standalone-web', {
							ns: 'moments',
						})}
					</LandingHeading>
					<LandingParagraph>
						{t('hubmomentslandingpage_text_christmas_standalone-web', {
							ns: 'moments',
						})}
					</LandingParagraph>
				</>
			}
			cta={
				<LandingButtonLink
					tracking={{eventaction: 'discover', eventlabel: 'christmas'}}
					href={'/moments/christmas'}
				>
					{t('generic_action_christmasmusic_standalone-web', {ns: 'common'})}
				</LandingButtonLink>
			}
			image={
				<Image
					sizes={{base: '100vw', md: '50vw'}}
					h={{base: '350px', md: '100%'}}
					src="561d3bbb244c75557af305876df56c76.jpg"
					aspectRatio="2048/1707"
					alt={t('metatag_text_christmaswithmusic_standalone-web', {
						ns: 'common',
					})}
				/>
			}
		/>
	);
};
